//hide top bar
export function iosHideTopBar() {
  if (window?.webkit?.messageHandlers?.setTopBar) {
    window.webkit.messageHandlers.setTopBar.postMessage({
      visible: false,
    });
  }
}

// show top bar
export function useIosShowTopBar() {
  if (window?.webkit?.messageHandlers?.setTopBar) {
    window.webkit.messageHandlers.setTopBar.postMessage({
      visible: true,
    });
  }
}

export function isIOSAppUser() {
  if (typeof window != 'undefined')
    return window &&
      window['webkit'] &&
      window['webkit'].messageHandlers &&
      window['webkit']?.messageHandlers?.getUserData
      ? true
      : false;
}

export function iosUserData() {
  if (typeof window != 'undefined')
    return window?.webkit?.messageHandlers?.getUserData?.postMessage({});
}

/**
 * This function is responsible to fire ios's native web view go back event
 */
export function iosCanWebViewGoBack() {
  // Execute ios's webGoBack function
  if (window?.webkit?.messageHandlers?.webGoBack) {
    window.webkit.messageHandlers.webGoBack.postMessage({});
    // return weather ios's webGoBack function was available
    return true;
  }
  return false;
}

/**
 * Enable or disabe back press
 * @param {Boolean} bool - enable back (true) to go back
 * or disable back (false) to exit app
 */
export function useIosShowHideBack(bool) {
  if (window?.webkit?.messageHandlers?.showhideBackButton) {
    window.webkit.messageHandlers.showhideBackButton.postMessage({
      visible: bool,
    });
  }
}

export function useIosLogFirebaseEvent(name, body) {
  if (window?.webkit?.messageHandlers?.logFirebaseEvent) {
    window.webkit.messageHandlers.logFirebaseEvent.postMessage({
      name: name,
      body: body,
    });
  }
}

/**
 * To request location permission to user in Ios
 */
export function useIosRequestOrGrantLocationPermission() {
  if (window?.webkit?.messageHandlers?.requestOrGrantLocationPermission) {
    window.webkit.messageHandlers.requestOrGrantLocationPermission.postMessage(
      {},
    );
  }
}

export function useIosRemoveOtiNuxStrip() {
  if (window?.webkit?.messageHandlers?.removeOtiNuxStrip) {
    window.webkit.messageHandlers.removeOtiNuxStrip.postMessage({
      visibility: false,
    });
  }
}

export function useIosEnableBack() {
  if (window?.webkit?.messageHandlers?.enableBack) {
    window.webkit.messageHandlers.enableBack.postMessage({
      visible: true,
    });
  }
}

export function useIosSetCart(bool) {
  if (window?.webkit?.messageHandlers?.setCart) {
    window.webkit.messageHandlers.setCart.postMessage({
      visible: bool,
    });
  }
}

//hide bottom bar
export function useIosHideBottomBar() {
  if (window?.webkit?.messageHandlers?.setBottomBarVisibility) {
    window.webkit.messageHandlers.setBottomBarVisibility.postMessage({
      visible: false,
    });
  }
}

export function useIosSetTitle(title) {
  if (window?.webkit?.messageHandlers?.setTitle) {
    window.webkit.messageHandlers.setTitle.postMessage({
      title: title,
    });
  }
}

export function useIoshandleBackPress() {
  if (window?.webkit?.messageHandlers?.handleBackPress) {
    window.webkit.messageHandlers.handleBackPress.postMessage({
      visible: true,
    });
  }
}

export function useIossetBottomBarVisibility(bool) {
  if (window?.webkit?.messageHandlers?.setBottomBarVisibility) {
    window.webkit.messageHandlers.setBottomBarVisibility.postMessage({
      visible: bool,
    });
  }
}

export function useIossetShowHideSideDrawerMenu(bool) {
  if (window?.webkit?.messageHandlers?.showHideSideDrawerMenu) {
    window.webkit.messageHandlers.showHideSideDrawerMenu.postMessage({
      visible: bool,
    });
  }
}

export function useIosSetSearch(bool) {
  if (window?.webkit?.messageHandlers?.setSearch) {
    window.webkit.messageHandlers.setSearch.postMessage({
      visible: bool,
    });
  }
}

export function iosOpenReviewListPage(productId) {
  if (window?.webkit?.messageHandlers?.openReviewListPage) {
    window.webkit.messageHandlers.openReviewListPage.postMessage({
      productId: productId,
    });
  }
}

export function iosOpenArticleDetailPage(contentId) {
  if (window?.webkit?.messageHandlers?.openArticleDetailPage) {
    window.webkit.messageHandlers.openArticleDetailPage.postMessage({
      contentId: contentId,
    });
  }
}

export function iosOpenDeeplink(deeplink, deeplinkValue) {
  if (window?.webkit?.messageHandlers?.openDeeplink) {
    window.webkit.messageHandlers.openDeeplink.postMessage({
      deeplink: deeplink.toString(),
      deepLinkValue: deeplinkValue,
    });
  }
}

export function useIosToast(textMsg) {
  if (window?.webkit?.messageHandlers?.showToast) {
    window.webkit.messageHandlers.showToast.postMessage({
      message: textMsg,
    });
  }
}

export function useIosFetchUserDetails() {
  if (window?.webkit?.messageHandlers?.getUserData) {
    window.webkit.messageHandlers.getUserData.postMessage({});
  }
}

export function useIosExitWebView() {
  if (window?.webkit?.messageHandlers?.exitWebView) {
    window.webkit.messageHandlers.exitWebView.postMessage({});
  }
}

export function useIosRefreshWalletPage() {
  if (window?.webkit?.messageHandlers?.refreshWalletPage) {
    window.webkit.messageHandlers.refreshWalletPage.postMessage({});
  }
}

// export async function iosUserdata() {
//     if (typeof window != "undefined") {
//         console.log('inside IOS');
//         window["setUserData"] = function (base64stringifiedJson) {
//             console.log('inside Window')
//             let stringifiedJson = window.atob(base64stringifiedJson);
//             let Userdata = JSON.parse(stringifiedJson);
//             console.log('Userdata', Userdata);
//             return Userdata;
//         };
//     }
// }
